import { memo } from 'react'

import { type ColorToken, colorTokens } from '../../foundations/color-tokens.ts'
import type { CompoundIconName } from '../../foundations/icon/names.ts'
import type { IconSize } from '../../foundations/icon/sizes.ts'
import type { IllustrationName } from '../../foundations/illustration/list.ts'

import { Avatar } from './avatar.tsx'

type AvatarDecorativeBaseProps = { size: IconSize; className?: string | undefined }

export type AvatarDecorativeWithIconProps = AvatarDecorativeBaseProps & {
  icon: CompoundIconName
  backgroundColorToken?: ColorToken
}
export type AvatarDecorativeWithIllustrationProps = AvatarDecorativeBaseProps & { illustration: IllustrationName }

export type AvatarDecorativeProps = AvatarDecorativeWithIconProps | AvatarDecorativeWithIllustrationProps

export const AvatarDecorative = memo<AvatarDecorativeProps>(function AvatarDecorative(props) {
  return 'illustration' in props ? (
    <Avatar illustration={props.illustration} size={props.size} className={props.className} />
  ) : (
    <Avatar
      icon={props?.icon}
      size={props.size}
      color={colorTokens['color-fg-decorative']}
      className={props.className}
      variant="contained"
      containerColor={colorTokens[props.backgroundColorToken ?? 'color-bg-brand-light']}
    />
  )
})
